export enum CustomErrorCode {
  FAILED_TO_SAVE_JOBSITE = 'FAILED_TO_SAVE_JOBSITE',
  INVALID_BRANCH = 'INVALID_BRANCH',
  INVALID_CART = 'INVALID_CART',
  INVALID_JOBSITE = 'INVALID_JOBSITE',
  INVALID_SHIFT_OR_RPP = 'INVALID_SHIFT_OR_RPP',
  INVALID_QUOTE = 'INVALID_QUOTE',
  INVALID_PRESIGNED_URL = 'INVALID_PRESIGNED_URL',
  LOCATION_NOT_SELECTED = 'LOCATION_NOT_SELECTED',
  PRICE_MISMATCH = 'PRICE_MISMATCH',
  UPLOAD_CANCELLED = 'UPLOAD_CANCELLED',
  INVALID_COMPANY_ID = 'INVALID_COMPANY_ID',
}
